import { Component, OnInit} from '@angular/core';

import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { CuratedMentionListDisplayElementModel } from '@Monitor/Briefings/models/curated-mention-list-display-element.model';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { RightSidebarComponent } from '@Common/Layout/components/RightSidebar/right-sidebar.component';

@Component({
    selector: 'agpr-curated-info-section',
    templateUrl: './curated-info-section.component.html',
    styleUrls: ['./curated-info-section.component.scss'],
    standalone: false
})
export class CuratedInfoSectionComponent extends AbstractFormFieldComponent implements OnInit {

    public readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;
    mentionCount: number = 0;

    constructor(public rhp: RightSidebarComponent) {
        super();
    }

    ngOnInit() {
        this.mentionCount = (this.block?.displayElement as CuratedMentionListDisplayElementModel)?.mentions?.length;
    }

    goToSortTool() {
        this.rhp.selectTabByIndex(2);
    }
}

